import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function SupportBanner() {
  return (
    <section className="bg-[#0A192F] pb-28 pt-4" data-testid="support-banner-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] border border-[#1D8A99]/25 bg-gradient-to-br from-[#0F213D] to-[#0C2B33] p-10 sm:p-14">
            <div
              className="pointer-events-none absolute inset-0"
              style={{ background: "radial-gradient(500px 260px at 85% 15%, rgba(37,165,183,0.22), transparent 65%)" }}
            />
            <div className="relative flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
              <div className="max-w-xl">
                <p className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-[#25A5B7]">
                  Support
                </p>
                <h2 className="mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl">
                  Need help with Knot Forgotten?
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-300 sm:text-base">
                  Contact us at{" "}
                  <a
                    href="mailto:knotforgottenapp@gmail.com"
                    data-testid="banner-mailto-link"
                    className="font-semibold text-[#25A5B7] underline decoration-[#25A5B7]/40 underline-offset-4 transition-colors hover:text-white"
                  >
                    knotforgottenapp@gmail.com
                  </a>{" "}
                  — or browse the answers on our support page.
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row md:flex-col">
                <a
                  href="mailto:knotforgottenapp@gmail.com"
                  data-testid="banner-email-button"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1D8A99] px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#25A5B7] hover:shadow-[0_10px_40px_-10px_rgba(29,138,153,0.6)]"
                >
                  <Mail className="h-4 w-4" />
                  Email us
                </a>
                <Link
                  to="/support"
                  data-testid="banner-support-link"
                  className="inline-flex items-center justify-center rounded-full border border-white/20 px-7 py-3.5 text-sm font-semibold text-slate-200 transition-colors duration-300 hover:border-white/40 hover:text-white"
                >
                  Visit support
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
